import * as i18n from "../../i18n.ts";
import * as Html from "../../util/Html.ts";
import * as modal from "../../util/modal.ts";
import * as forms from "../../util/forms.js";
import * as amplify from "../../util/amplify.ts";

import ApiServer from "../../ApiServer.js";


function init(trNode){
  var 
    amountInput = trNode.find('input[name=amount]'),
    dateInput = trNode.find('input[name=startDate]'),
    categorySelect = trNode.find('select[name=budgetCategoryId]');
  
  
  amountInput.amountValue(0);
  trNode.find('td').css('overflow','visible')
  
  trNode.find('input, select').on("keydown" ,(ev=>{
    if(ev.keyCode===10 || ev.keyCode===13){
      trNode.trigger('submit')
    }
    if(ev.keyCode===27){//escape
      trNode.remove()
    } 
  }))
  amountInput.on('change',function(){
    var value = Math.abs(amountInput.amountValue())
    if(isNaN(value)||value===0){
      forms.markInvalid(amountInput,i18n.get('budget.transactionerrors.amount')).select()
    }else{
      amountInput.amountValue(value)
      forms.markValid(amountInput)
    }
  })
  amountInput.on('focus',function(){
    this.select()
  })
  trNode.on('submit',function(event){
    var value = Math.abs(amountInput.amountValue())
    if(isNaN(value)||value===0){
      forms.markInvalid(amountInput,i18n.get('budget.transactionerrors.amount')).select()
      return;
    }
    ApiServer.budgettransactionput(trNode.get(0),function(){
      amplify.publish("tableaddmode",true)
    },function(err){
      if(err.code==='502' && err.message.indexOf('non-recurrent budget')>-1){
        modal.alert({title:'communication.justonemorething',message:"fw2.apierrors.502transactionrecurrencyend"},function(){
          $('*[data-widget="widget/form/recurrencyend"]').click()
        })
      }else{
        throw err;
      }
    })
  })
  
}
Html.registerWidget('widget/form/budgetTransactionInlineForm',{init:init})
